export default  {
  infura_key: '9e92c574cb904603932c65a1ca12da66',
  contract_address: '0x9f648eef45b73e1A32ce7b624A44266226a85d88',
  // contract_address: '0x84EE114Ff1a8e2aFDA09Ff1C1E993950B762dCec', //rinkeby
  // contract_address: '0x0165878A594ca255338adfa4d48449f69242Eb8F', //local
}
